var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sign out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "topnav-/-2",
    transform: "translate(-1245.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "topnav-/-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-out",
    transform: "translate(1245.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bakgrunnur",
    fill: "#FFFFFF",
    opacity: 0.2,
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.862069,31.6833333 L18.1724138,31.6833333 C17.1172414,31.6833333 16.3103448,30.86 16.3103448,29.7833333 L16.3103448,15.2166667 C16.3103448,14.14 17.1172414,13.3166667 18.1724138,13.3166667 L26.862069,13.3166667 C27.9172414,13.3166667 28.7241379,14.14 28.7241379,15.2166667 L28.7241379,16.3333333 C28.7241379,16.5233333 28.6,16.65 28.4137931,16.65 C28.2275862,16.65 28.1034483,16.5233333 28.1034483,16.3333333 L28.1034483,15.2166667 C28.1034483,14.52 27.5448276,13.95 26.862069,13.95 L18.1724138,13.95 C17.4896552,13.95 16.9310345,14.52 16.9310345,15.2166667 L16.9310345,29.7833333 C16.9310345,30.48 17.4896552,31.05 18.1724138,31.05 L26.862069,31.05 C27.5448276,31.05 28.1034483,30.48 28.1034483,29.7833333 L28.1034483,28.6666667 C28.1034483,28.4766667 28.2275862,28.35 28.4137931,28.35 C28.6,28.35 28.7241379,28.4766667 28.7241379,28.6666667 L28.7241379,29.7833333 C28.7241379,30.86 27.9172414,31.6833333 26.862069,31.6833333 Z",
    id: "Shape",
    stroke: "#E9E9E9",
    strokeWidth: 0.8,
    fill: "#E9E9E9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0689655,23.1333333 L23.7586207,23.1333333 C23.5724138,23.1333333 23.4482759,23.0066667 23.4482759,22.8166667 C23.4482759,22.6266667 23.5724138,22.5 23.7586207,22.5 L33.0689655,22.5 C33.2551724,22.5 33.3793103,22.6266667 33.3793103,22.8166667 C33.3793103,23.0066667 33.2551724,23.1333333 33.0689655,23.1333333 Z",
    id: "Shape",
    stroke: "#E9E9E9",
    strokeWidth: 0.8,
    fill: "#E9E9E9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6172414,26.205 C30.5551724,26.205 30.4310345,26.205 30.3689655,26.1416667 C30.2448276,26.015 30.2448276,25.825 30.3689655,25.6983333 L33.2241379,22.785 L30.3689655,19.8716667 C30.2448276,19.745 30.2448276,19.555 30.3689655,19.4283333 C30.4931034,19.3016667 30.6793103,19.3016667 30.8034483,19.4283333 L33.9068966,22.595 C34.0310345,22.7216667 34.0310345,22.9116667 33.9068966,23.0383333 L30.8034483,26.205 C30.8034483,26.205 30.6793103,26.205 30.6172414,26.205 Z",
    id: "Shape",
    stroke: "#E9E9E9",
    strokeWidth: 0.8,
    fill: "#E9E9E9",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.c2738a051aeff1ec0865190abc714e61.svg";
export { ForwardRef as ReactComponent };